<template>
  <v-row no-gutters class="align-center" v-if="user">
    <v-col cols="3" align="center" v-if="!hideName">
      <user-avatar :user="user" small />
    </v-col>
    <v-col cols="9" class="pl-2" v-if="!dense">
      <div v-if="!hideName">
        <router-link
          v-if="routerLink"
          class="text-link font-weight-medium"
          :to="{ name: 'User', params: { user: user, userId: user.id } }"
        >
          {{ user | userName }}
          <chip-blocked v-if="!user.is_active" class="ml-2"></chip-blocked>
          <chip-external v-if="user.is_external" class="ml-2"></chip-external>
        </router-link>
        <div v-if="!routerLink" class="font-weight-medium">
          {{ user | userName }}
          <chip-blocked v-if="!user.is_active" class="ml-2"></chip-blocked>
        </div>
      </div>
      <div v-if="workInfo(user)" class="text-subtitle-1">
        <v-icon small class="mr-1">
          mdi-briefcase-outline
        </v-icon>
        {{ workInfo(user) }}
      </div>
      <div>
        <v-icon small class="mr-1" v-if="user.email">mdi-email-outline</v-icon>
        <a
          v-bind:href="`mailto:${user.email}`"
          class="text-link text-subtitle-1"
        >
          {{ user.email }}
        </a>
      </div>
      <div>
        <v-icon small class="mr-1" v-if="user.phone">mdi-cellphone</v-icon>
        <a
          v-bind:href="`tel:${user.phone}`"
          class="text-link text-subtitle-1"
        >
          {{ user.phone }}
        </a>
      </div>
      <div v-if="routerLink">
        <v-tooltip bottom v-for="(site, index) in user.sites" :key="index">
          <template v-slot:activator="{ on }">
            <router-link
            class="text-link font-weight-medium"
            :to="{ name: 'Site', params: { site: site, siteId: site.id } }"
            >
            <v-chip v-if="!site.code_name" v-on="on" small class="mr-2 blue" text-color="white">{{ "Dostęp globalny"}}</v-chip>
            <v-chip v-if="site.code_name" v-on="on" small class="mr-2">{{ site.code_name }}</v-chip>
          </router-link>
          </template>
          <div>{{ site.name }}</div>
        </v-tooltip>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import { userWorkInfo } from "@/filters/user"

export default {
  name: "UserInfo",
  data() {
    return {}
  },
  props: {
    hideName: {
      type: Boolean,
      default: false
    },
    routerLink: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: null
    }
  },
  methods: {
    workInfo(user) {
      return userWorkInfo(user)
    }
  }
}
</script>

<style lang="sass">
.mp-avatar
  border-style: solid
  border-color: #00000008
  border-width: 1px
</style>